import { render, staticRenderFns } from "./CampaignPageTable.vue?vue&type=template&id=fdcdc47e&scoped=true"
import script from "./CampaignPageTable.vue?vue&type=script&lang=js"
export * from "./CampaignPageTable.vue?vue&type=script&lang=js"
import style0 from "./CampaignPageTable.vue?vue&type=style&index=0&id=fdcdc47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcdc47e",
  null
  
)

export default component.exports